import { render, staticRenderFns } from "./quiz-result.vue?vue&type=template&id=cb2a56b0"
import script from "./quiz-result.vue?vue&type=script&lang=js"
export * from "./quiz-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports